// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"6bc9509f","166":"fbe006e9","218":"a3196925","405":"57bef169","488":"dd5ebaad","745":"a8f5e6c6","791":"3068db5b","871":"1b0fca63","883":"0291414c"}[chunkId] + ".chunk.js";
};